module.exports = __webpack_public_path__ + "static/media/rocket.145a6076.gif";